var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedHrt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ffd3d1;}.b{fill:#f13f37;}.c{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 34.5,
    cy: 34.5,
    r: 34.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M29.438,4.2a8.708,8.708,0,0,0-11.882.866L16.3,6.357,15.047,5.064A8.707,8.707,0,0,0,3.165,4.2a9.143,9.143,0,0,0-.63,13.238L14.856,30.159a2,2,0,0,0,2.885,0L30.062,17.437A9.138,9.138,0,0,0,29.438,4.2Z",
    transform: "translate(17.721 18.966)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.379 29.882)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.798,
    height: 9.327,
    transform: "translate(3.264)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 2.798,
    height: 9.327,
    transform: "translate(9.327 3.264) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedHrt);
export default __webpack_public_path__ + "static/media/red_hrt.dd54a1d4ac4bf2b9d2f90d2f7d889dc9.svg";
export { ForwardRef as ReactComponent };